export const spacingTokens = {
  '0': {
    default: 0,
    lg: 0
  },
  'headlines/small': {
    default: 2,
    lg: 0
  },
  'headlines/medium': {
    default: 4,
    lg: 8
  },
  'headlines/large': {
    default: 8,
    lg: 16
  },
  'headlines/xLarge': {
    default: 16,
    lg: 24
  },
  'pages/small': {
    default: 16,
    lg: 24
  },
  'pages/medium': {
    default: 24,
    lg: 40
  },
  'pages/large': {
    default: 32,
    lg: 48
  },
  'dividers/medium': {
    default: 12,
    lg: 16
  },
  'boxes/medium': {
    default: 12,
    lg: 16
  },
  'lists/small': {
    default: 4,
    lg: 4
  },
  'lists/medium': {
    default: 8,
    lg: 8
  },
  'lists/large': {
    default: 16,
    lg: 16
  },
  'global/small': {
    default: 0,
    lg: 0
  },
  'global/medium': {
    default: 8,
    lg: 8
  },
  'global/large': {
    default: 16,
    lg: 16
  }
};